<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <div class="text-left">
                <v-btn icon v-on="on" :disabled="borrando">
                    <v-icon color="primary">mdi-trash-can-outline</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{ $t('dialog_titulo') }}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrar()" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                      <span v-html="$t('preg_borrar', {material:material.codigo + ' - ' + material.material.nombre})" />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="secondary" :disabled="borrando" text @click="dialog = false">
                    {{ $t('cerrar') | capitalize }}
                </v-btn>
                <v-btn color="error" depressed :loading="borrando" @click="borrar()">
                    {{ $t('borrar') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";

    export default {
        name: "BtnBorrarMaterial",
        props: {
            material: {type: Object, required: true},
        },
        data: () => ({
            dialog: false,
            borrando: false
        }),
        methods: {
            borrar() {
                this.borrando = true;

                HttpHelper.get(`material-personalizado/${this.material.id}/borrar`)
                    .then(() => {
                        this.dialog = false;
                        this.$emit("borrado");
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.borrando = false;
                    });

            },
            cerrar() {
                this.dialog = false;
            }
        },
    }
</script>

<style scoped>

</style>
<i18n>
{
"es": {
"dialog_titulo": "Confirmación de borrado",
"preg_borrar": "¿Estás seguro de que quieres borrar el material <span class='font-weight-bold'>{material}</span>?",
"borrar": "Borrar",
"cerrar": "Cerrar"
}
}
</i18n>
